/**
 * 网页 Google 登录 —— 授权码重定向流的前端半边(2026-09-09,弃 GIS iframe:
 * 弹窗流在第三方 Cookie 被禁的浏览器里死在空白 /gsi/transform——没登录过
 * Google 的人必现,Chrome 正在全面禁第三方 Cookie;iframe 按钮的语言与样式
 * 也不归我们管)。按钮完全自绘(google-button.tsx 的 GoogleG 是官方四色 G),
 * 点击整页去 /api/auth/google/start,服务端换码建号种会话后跳回;落地用
 * hash 报结果(#ember-google=new|linked|conflict),读一次即抹。
 *
 * client id 是公开值,build 时经 VITE_GOOGLE_CLIENT_ID 注入;没配就没有任何
 * Google 门(App 的 GIDClientID 闸同款)。真正的凭证交换全在服务端
 * (app-auth-routes 的 start/callback,secret 不出后端)。
 */

import { armPhoneHint } from './phone-hint';

export const GOOGLE_CLIENT_ID = String(import.meta.env.VITE_GOOGLE_CLIENT_ID || '').trim();

/** 登录门的出发地址;return_to 只认本站路径(服务端还会再验一遍)。 */
export function googleSignInHref(returnTo: string, apiBase = ''): string {
  return `${apiBase}/api/auth/google/start?return_to=${encodeURIComponent(returnTo || '/')}`;
}

/** Settings 绑定行:同一扇门的 link 模式——身份挂到当前会话的账号,不换人。 */
export function googleLinkHref(returnTo: string, apiBase = ''): string {
  return `${googleSignInHref(returnTo, apiBase)}&mode=link`;
}

/**
 * Confirm it's you (2026-10-19 Riley): the same door in reauth mode — the account's own Google, checked and
 * stamped on this session for five minutes; nobody is signed in or linked. Lands back with
 * #ember-reauth=google | not_this_account | rate_limited.
 */
export function googleReauthHref(returnTo: string, apiBase = ''): string {
  return `${googleSignInHref(returnTo, apiBase)}&mode=reauth`;
}

export type ReauthLanding = '' | 'google' | 'not_this_account' | 'rate_limited';

/** Read once on landing, then wiped, as the Google landing is. */
export function consumeReauthLanding(): ReauthLanding {
  if (typeof window === 'undefined') return '';
  const m = window.location.hash.match(/^#ember-reauth=(google|not_this_account|rate_limited)$/);
  if (!m) return '';
  try {
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
  } catch { /* the pattern is the whole hash, so nothing half-replays */ }
  return m[1] as ReauthLanding;
}

export type GoogleLanding = '' | 'new' | 'linked' | 'conflict';

/**
 * 落地时读一次回跳 hash:'new' 顺手点亮「绑个手机号」的一次性红点;读完即抹,
 * 刷新不重放。SPA 壳和 Settings 都调——谁先挂载谁消费,另一个拿到 ''。
 */
export function consumeGoogleLanding(): GoogleLanding {
  if (typeof window === 'undefined') return '';
  const m = window.location.hash.match(/^#ember-google=(new|linked|conflict)$/);
  if (!m) return '';
  try {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  } catch { /* 抹不掉也无害:正则只认整串,不会半途重放 */ }
  const landing = m[1] as GoogleLanding;
  if (landing === 'new') armPhoneHint();
  return landing;
}
